const ENV = process.env.REACT_APP_ENV || "des";
const DOMAIN = process.env.REACT_APP_DOMAIN;

let urlBaseWeb = "landpage";
let urlDomain = `http://localhost:8000`;
if (DOMAIN !== undefined) {
  urlDomain = DOMAIN;
} else if (ENV === "azurepre") {
  urlDomain = `https://corpre.aleatica.com`;
  urlBaseWeb = `${urlDomain}/landpage`;
} else if (ENV === "test") {
  urlDomain = `https://labs-pre.aleatica.com`;
  urlBaseWeb = `${urlDomain}/landpage`;
} else if (ENV === "local") {
  urlDomain = `http://localdev.aleaticalabs.com:48082`;
  urlBaseWeb = `${urlDomain}/landpage`;
} else if (ENV === "pro" || ENV === "azurepro") {
  urlDomain = `https://labs.aleatica.com`;
} else {
  urlDomain = `https://cco${ENV}.aleaticalabs.com`;
}
urlBaseWeb = `${urlDomain}/landpage`;
console.log("ENV value", ENV, "domain ", DOMAIN, "urlDomain", urlDomain);

export const URL_DOMAIN = urlDomain;
export const urlFormLogin = `${urlBaseWeb}/login.html`;
export const urlFormLogout = `${urlBaseWeb}/logout`;
export const urlFormOas365 = `${urlBaseWeb}/oas365`;
export const urlLandingPage = `${urlDomain}/landpage`;
export const urlBaseDomain = `https://${urlDomain}/`;
export const urlLandingPageAccess = `${urlLandingPage}/authorize?client_id=landpage`;
export const urlContext = `${urlDomain}`;
export const urlApi = `${urlContext}/landpage`;
export const urlApiCControl = `${urlContext}/CControl`;
export const urlUsersApi = `${urlContext}/landing/users`;

export const urlLogout = `${urlApi}/logout`;
//USUARIO
export const urlUser = `${urlApi}/security/user`;
export const urlUserChangeLang = `${urlApi}/users/change-lang`;
export const urlUserCheckPass = `${urlApi}/AjaxServlet?url=auth/user/checkPass`;
export const urlUserChangePass = `${urlApi}/AjaxServlet?url=auth/user/changePass`;

//ROLES
export const urlRoles = `${urlApi}/AjaxServlet?url=auth/security/roles`;
export const urlSaveRol = `${urlApi}/AjaxServlet?url=auth/security/guardarRol`;
export const urlDeleteRol = `${urlApi}/AjaxServlet?url=auth/security/borrar/rol`;
export const urlRolId = `${urlApi}/AjaxServlet?url=auth/security/getRolId`;
export const urlModules = `${urlApi}/AjaxServlet?url=auth/security/modulos`;

//GRUPOS
export const urlGroups = (lang) => `${urlApi}/AjaxServlet?url=auth/security/grupo/${lang}`;
export const urlSaveGroup = `${urlApi}/AjaxServlet?url=auth/security/guardarGrupo`;
export const urlDeleteGroup = `${urlApi}/AjaxServlet?url=auth/security/borrar/grupo`;
export const urlHierarchy = (lang) => `${urlApi}/AjaxServlet?url=auth/security/jerarquia/${lang}`;
export const urlRolesGroup = (groupId) => `${urlApi}/AjaxServlet?url=auth/security/rolesGroup/${groupId}`;

//USUARIOS
export const urlUsers = (lang) => `${urlApi}/AjaxServlet?url=auth/security/usuario/reducida/${lang}`;
export const urlSaveUser = `${urlApi}/AjaxServlet?url=auth/security/usuario`;
export const urlConcessions = `${urlApi}/AjaxServlet?url=auth/security/paises/concesiones`;
export const urlUserResetPassword = `${urlApi}/AjaxServlet?url=auth/user/resetpassword`;
export const urlActiveGroups = (lang) => `${urlApi}/AjaxServlet?url=auth/security/gruposactive/${lang}`;
export const urlLanguages = (lang) => `${urlApi}/AjaxServlet?url=auth/language/languages/${lang}`;
export const urlCheckLogin = (login) => `${urlApi}/AjaxServlet?url=auth/security/usuario/existe/${login}/`;
export const urlDeleteUser = (login) => `${urlApi}/AjaxServlet?url=auth/security/borrar/usuario/${login}/`;
export const urlChangeUserRoles = `${urlApi}/AjaxServlet?url=auth/security/guardarRolesUser`;
export const urlUserRoles = (login) => `${urlApi}/AjaxServlet?url=auth/security/rolesUser/${login}/`;
export const urlActiveUsers = `${urlApi}/AjaxServlet?url=auth/security/active_users`;
export const urlFindUserByEmail = (email) => `${urlApi}/AjaxServlet?url=auth/user/_find_user_by_email/${email}/`;

//ACCIONES
export const urlRol = (rolId) => `${urlApi}/AjaxServlet?url=auth/security/rol/${rolId}`;
export const urlRolActions = (lang, moduleId, rolId) =>
  `${urlApi}/AjaxServlet?url=auth/security/arbolAcciones/${lang}/${moduleId}/${rolId}`;

export const urlSaveRolActions = `${urlApi}/AjaxServlet?url=auth/security/guardaAcciones`;

//ESTUDIOS CDT
export const urlCdtStudies = `${urlApi}/AjaxServlet?url=auth/preform/estudioscdt`;

//ENVÍO DE COMENTARIOS
export const urlComments = `${urlApi}/captcha/validate?url=commentary`;

//APPS
export const urlApps = `${urlApi}/AjaxServlet?url=auth/user/user_modules`;
export const urlUserManager = `${urlApi}/AjaxServlet?url=auth/user/user_manager`;
export const urlSaveApp = `${urlApi}/AjaxServlet?url=auth/security/guardarModulo`;
export const urlCheckResponsiveApp = (appId) => `${urlApi}/AjaxServlet?url=auth/user/check_responsive/${appId}`;
export const urlResponsiveUpload = `${urlApi}/responsives/upload_responsive/`;

export const urlFindResponsivas = `${urlApi}/AjaxServlet?url=auth/security/responsives/_find`;
export const urlResponsiva = `${urlApi}/AjaxServlet?url=auth/security/responsives`;
export const urlResponsivaData = (id) => `${urlApi}/AjaxServlet?url=auth/security/responsive_data/${id}`;
export const urlResponsivaConfigData = `${urlApi}/AjaxServlet?url=auth/user/responsive_config_data`;
export const urlPdfResponsive = (id) => `${urlApi}/responsives/${id}/preview/pdf`;
